import styled from 'styled-components';
import { Box } from 'uisos';

export default styled(Box)`
  display: flex;
  background-color: #fffdfd;
  border-radius: 100%;
`;
